import axios from 'axios'

export default axios.create({
  baseURL: process.env.REACT_APP_KIS_URL,
  withXSRFToken: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
})

export const axiosPrivateKIS = axios.create({
  baseURL: process.env.REACT_APP_KIS_URL,
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
})
